// 项目排序规则
export enum EProjectsOrder {
    CreatedOn = '0',    // 创建时间
    EndOn = '10',    // 完成时间
    Status = '20',  // 项目状态（默认）
}